import { useCallback, useEffect, useState } from 'react';
import isNumber from 'lodash/isNumber';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setFilterOptions } from '@yme/pdp-components/ProductCard';
import { getFilterOptionByProductType } from '../../helpers';
import { prepareFrameSizeFilterOptions } from './EBikesFilter/helpers';
import { STATUS_CHANGE, STATUS_INIT, STATUS_RELOAD } from './constants';
import { getColorIndex } from './helpers';
export function useSizeFilter({ productFilterOptions, productVariantsByColor, colorVariants, isAccessoryOrApparel, }) {
    const [prevSizeValueState, setPrevSizeValueState] = useState('');
    const { sku, size, colorItemIndex = 0, isFilterChanged } = productFilterOptions;
    const dispatch = useDispatch();
    const history = useHistory();
    const { isEBikesFilter } = getFilterOptionByProductType({
        productVariantsByColor,
        colorItemIndex,
    });
    const isSizeFilterAllow = isAccessoryOrApparel || isEBikesFilter;
    const onChangeColor = useCallback((index, colourId) => {
        const newVariant = prepareFrameSizeFilterOptions({
            colorVariants,
            index,
            sku,
            size,
            statusType: STATUS_CHANGE,
        });
        if (newVariant?.sku && colorItemIndex !== index) {
            history.push({
                hash: newVariant.sku,
            });
            dispatch(setFilterOptions({
                colourId,
                colorItemIndex: index,
                isFilterChanged: true,
                sku: newVariant.sku,
            }));
        }
    }, [colorVariants, sku, size, colorItemIndex, history, dispatch]);
    const pageHash = history.location.hash.replace('#', '').trim();
    // E-Bikes Filter (Case 1 / Case 2 / Case 3)
    // Hook for define filter options:
    // Case 1 - if 'sku' doesn't exist in url with first load page (reload page);
    // Case 2 - if 'sku' exist in url with first load page (reload page);
    // Case 3 - if 'sku' exist in url, but wrong - redirect to page without sku (get sku with first valid options for filter);
    useEffect(() => {
        if (isSizeFilterAllow && !sku) {
            const colorIndex = productVariantsByColor && getColorIndex(productVariantsByColor, pageHash);
            if (isNumber(colorIndex)) {
                const currentVariant = prepareFrameSizeFilterOptions({
                    colorVariants,
                    index: colorIndex >= 0 ? colorIndex : 0,
                    sku: colorIndex >= 0 ? pageHash : '',
                    statusType: pageHash && colorIndex >= 0 ? STATUS_RELOAD : STATUS_INIT,
                });
                if (currentVariant?.sku) {
                    dispatch(setFilterOptions(currentVariant));
                }
            }
            if (colorIndex === -1) {
                history.replace({
                    hash: '',
                });
                if (prevSizeValueState) {
                    setPrevSizeValueState('');
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, productVariantsByColor, colorVariants]);
    // E-Bikes Filter (Case 4)
    // Hook for define new filter options:
    // after change options in filter or after switch color (index of color)
    useEffect(() => {
        if (isSizeFilterAllow && pageHash && sku && size && isFilterChanged) {
            const colorIndex = productVariantsByColor && getColorIndex(productVariantsByColor, pageHash);
            if (isNumber(colorIndex)) {
                const currentVariant = prepareFrameSizeFilterOptions({
                    colorVariants,
                    index: colorIndex,
                    sku: pageHash,
                    size: prevSizeValueState || size,
                    statusType: STATUS_CHANGE,
                });
                if (currentVariant?.sku && currentVariant?.size) {
                    dispatch(setFilterOptions(currentVariant));
                    if (prevSizeValueState) {
                        setPrevSizeValueState('');
                    }
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [colorVariants, dispatch, size, sku]);
    useEffect(() => {
        const onGoBackHandler = () => {
            const currentVariant = prepareFrameSizeFilterOptions({
                colorVariants,
                index: colorItemIndex,
                sku: pageHash,
                statusType: STATUS_RELOAD,
            });
            setPrevSizeValueState(currentVariant?.size);
        };
        window.addEventListener('popstate', onGoBackHandler);
        return () => {
            window.removeEventListener('popstate', onGoBackHandler);
        };
    }, [colorItemIndex, colorVariants, pageHash]);
    return {
        isSizeFilterAllow,
        isEBikesFilter,
        onChangeColor,
    };
}
